import {Component, OnInit} from '@angular/core';
import RfcFacil from 'rfc-facil';
import {Router} from '@angular/router';
import {StorageService} from '../../services/storage.service';
import {BidService} from '../../services/bid.service';
import * as moment from 'moment';
import {AlertService} from '../../services/alert.service';
import {CameraResultType, CameraSource, Plugins} from '@capacitor/core';
import {ActionSheetController, LoadingController} from '@ionic/angular';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

const {Camera} = Plugins;

@Component({
  selector: 'app-validar-rfc',
  templateUrl: './validar-rfc.page.html',
  styleUrls: ['./validar-rfc.page.scss'],
})
export class ValidarRfcPage implements OnInit {

  validateForm: FormGroup;

  ocrData: any = {
    name: '',
    firstSurname: '',
    dateOfBirth: '',
    curp: '',
    crc_section: '',
    claveElector: '',
    registry_year: '',
    rfc: ''
  };


  imageIneFrente: any = {};
  operationId;
  docType: string;
  valuePerson: string;
  personId: string;
  enableCurp: boolean;
  homoClave: string;
  continepage: boolean;
  rfcUpload: boolean;
  next: boolean;

  rfcOrigin: string;


  constructor(private router: Router, private storageService: StorageService,
              private bidService: BidService, private alertService: AlertService,
              private actionSheetCtrl: ActionSheetController, private fb: FormBuilder, private loadingController: LoadingController) {


    this.imageIneFrente = {};
    this.rfcUpload = false;
    this.next = false;
    this.storageService.getStorage('personIdRegister').then((op: any) => {
      if (op.value !== null) {
        this.personId = op.value;
      } else {
        this.storageService.getStorage('personID').then((p: any) => {
          if (p.value !== null) {
            this.personId = p.value;
          }
        });
      }
    });


    this.storageService.getStorage('operationID').then((op: any) => {

      this.operationId = op.value;
    });

    this.storageService.getStorage('docType').then((doc: any) => {
      this.docType = doc.value;
    });

    this.storageService.getStorage('valuePerson').then((doc: any) => {
      this.valuePerson = doc.value;
    });


    this.storageService.getStorage('OCR').then((val: any) => {

      if (val.value !== null) {

        this.ocrData = JSON.parse(val.value);

        if (this.ocrData.curp !== null && this.ocrData.curp !== '' && this.ocrData.curp !== undefined) {
          this.enableCurp = true;
          this.validateForm.controls['curp'].setValue(this.ocrData.curp);
          this.validateForm.controls['curp'].disable();

        }
        const date = moment(this.ocrData.dateOfBirth, 'YYYY-MM-DD');
        
        const rfc: string = RfcFacil.forNaturalPerson({
          name: this.ocrData.name,
          firstLastName: this.ocrData.firstSurname,
          secondLastName: this.ocrData.secondSurname,
          day: Number(date.format('D')),
          month: Number(date.format('M').toString()),
          year: Number(date.format('YYYY').toString())
        });

        this.rfcOrigin = rfc;
        this.ocrData.rfc = rfc;
        this.validateForm.controls['rfc'].setValue(this.ocrData.rfc);
        this.homoClave = this.ocrData.rfc.substr(this.ocrData.rfc.length - 3);
      }
    });


  }

  get curp() {
    return this.validateForm.get('curp');
  }

  get rfc() {
    return this.validateForm.get('rfc');
  }

  ngOnInit() {

    this.imageIneFrente = {};
    this.rfcUpload = false;
    this.next = false;
    this.validateForm = this.fb.group({

      secondSurname: ['', []],
      curp: ['', [Validators.required]],
      registry_year: ['', []],
      claveElector: ['', [Validators.required]],
      crc_section: ['', [Validators.required]],
      dateOfBirth: ['', [Validators.required]],
      rfc: ['', [Validators.required]],
      firstSurname: ['', []],
      name: ['', []]
    });


    this.validateForm.get('curp').valueChanges.subscribe((event) => {

      this.validateForm.get('curp').setValue(event.toUpperCase(), {emitEvent: false});
    });

    this.validateForm.get('rfc').valueChanges.subscribe((event) => {

      const rfc = this.rfcOrigin.substr(0, 10);
      let homoclave = '';
      if (event.length === 13) {
        homoclave = event.substr(event.length - 3);
      }

      if (event.length === 12) {
        homoclave = event.substr(event.length - 2);
      }

      if (event.length === 11) {
        homoclave = event.substr(event.length - 1);
      }

      let rfcFinal = rfc;
      if (event !== rfc) {
        rfcFinal = rfc;
      } else {
        rfcFinal = rfc;
      }

      const res = rfcFinal + homoclave;
      this.validateForm.get('rfc').setValue(res.toUpperCase(), {emitEvent: false});
    });
  }

  nextPage() {

    const reqIne = {
      operationId: this.operationId,
      data: {
        curp: this.validateForm.controls['curp'].value
      }
    };


    this.bidService.validateRenapo(reqIne).subscribe((curp: any) => {

      if (curp.error !== undefined) {
        this.alertService.presentAlert('Datos incorrectos', 'CURP no  valido').then();
      } else {
        this.alertService.presentToastPosition('primary', 'CURP válido', 'top').then();
        let reqOp;

        switch (this.docType) {
          case 'Identificación INE':
            reqOp =
              {
                personId: this.personId,
                catIdentificationId: '2',
                value: this.valuePerson,
                active: true,
              };
            break;

          case 'Cedula Profesional':
            reqOp =
              {
                personId: this.personId,
                catIdentificationId: '8',
                value: this.valuePerson,
                active: true,
              };
            break;
          case 'Pasaporte Mexicano':
            reqOp =
              {
                personId: this.personId,
                catIdentificationId: '4',
                value: this.valuePerson,
                active: true,
              };
            break;

          case 'Forma Migratoria':
            reqOp =
              {
                personId: this.personId,
                catIdentificationId: '7',
                value: this.valuePerson,
                active: true,
              };
            break;
        }


        const reqPerson = {
          ssn: this.validateForm.controls['curp'].value,
          identification: this.validateForm.value.rfc,
        };

        this.bidService.updatePerson(this.personId, reqPerson).subscribe(data => {

        });
        this.bidService.personIdentification(reqOp).subscribe(data => {

        });

        const req = {
          currentSecuenceId: '11',
          activityValue: 'RFC_OK'
        };
        this.bidService.updateOperation(this.operationId, req).subscribe(() => {
          this.router.navigateByUrl('guardar-enrolamiento');
        });
      }
    }, error => {

      this.alertService.presentAlert('Error', 'CURP no valido');
    });


  }

  changeRFC() {

    if (this.homoClave !== undefined) {


      const homoClaveChange = this.validateForm.value.rfc.substr(this.validateForm.value.rfc.length - 3);

      if (this.homoClave !== homoClaveChange) {
        this.rfcUpload = true;
        this.next = true;
      } else {
        this.next = false;
        this.rfcUpload = false;
      }

      if (this.validateForm.value.rfc.length === 13) {
        if (this.homoClave !== homoClaveChange) {
          this.next = true;
        } else {
          this.next = false;
        }
      } else {
        this.next = true;
      }
    }

  }

  async selectImageSource(typeIne) {
    const buttons = [
      {
        text: 'Tomar una foto',
        icon: 'camera',
        handler: () => {
          this.addImage(CameraSource.Camera, typeIne);
        }
      }
    ];

    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Seleccionar',
      buttons
    });
    await actionSheet.present();
  }

  async addImage(source: CameraSource, typeIne: string) {
    const image = await Camera.getPhoto({
      webUseInput: true,
      quality: 10,
      correctOrientation: true,
      resultType: CameraResultType.Base64,
      source
    });


    if (typeIne === 'ineAdelante') {
      this.imageIneFrente = {
        _id: '1',
        name: 'imageName',
        createdAt: new Date(),
        base64: `${image.base64String}`,
        url: `data:image/${image.format};base64,${image.base64String}`,
        blob: ''
      };

      const rawData = atob(this.imageIneFrente.base64);
      const bytes = new Array(rawData.length);
      for (let x = 0; x < rawData.length; x++) {
        bytes[x] = rawData.charCodeAt(x);
      }

      const arr = new Uint8Array(bytes);
      const blob = new Blob([arr], {type: `image/${image.format}`});
      this.imageIneFrente.blob = blob;

      this.uploadFileImage(this.imageIneFrente.blob, 'RFC');
    }
  }

  deleteImage(index) {
    if (index === 'imageIneFrente') {
      this.imageIneFrente = {};
      this.continepage = true;

    }

  }

  async uploadFileImage(blob, type) {

    this.loadingController.getTop().then(hasLoading => {
      this.loadingController.create({
        spinner: 'circular',
        translucent: true
      }).then(loading => loading.present());
    });

    const code = 'RFC';
    const form = new FormData();
    const file = this.blobToFile(blob, 'my-image.jpeg');

    form.append('document', file);
    form.append('operationId', this.operationId);
    form.append('contentType', 'image/jpeg');
    form.append('documentCode', code);
    form.append('extension', 'jpeg');
    form.append('folderDescripcion', 'RFC');
    form.append('folderPath', '1');
    form.append('folderTitle', code);
    form.append('name', 'RFACIAL');


    this.bidService.uploadFile(form).subscribe((data: any) => {

      this.storageService.saveToStorage('documentId' + type, data.id);
      this.next = false;
      this.loadingController.dismiss().then();
    }, error => {
      this.loadingController.dismiss().then();
    });


  }

  blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  }

  backPage() {

  }
}
